<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="flex_box_bt">
				<div class="fl">
					<ul class="ableft_menu">
						<li @click="chose(index)" :class="{'active':active == item.id}" v-for="(item, index)  in list">
							{{item.title}}</li>
					</ul>
				</div>
				<div class="fr">
					<h1 class="title">{{title}}</h1>
					<div class="con"  v-html="content">
						
					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title:"",
				index:0,
			}
		},
		created: function(data) {
			if(this.$route.query.id != undefined){
				this.active = this.$route.query.id	
				this.index = this.$route.query.index	
			}
			this.getmenu();

		},
		watch: {
			$route() {

			}
		},
		methods: {
			chose(index) {
				this.$data.active = this.$data.list[index].id;
				this.content = this.$data.list[index].content;
			},
			getmenu() {
				var that = this;
				this.rq.requests.post("api/hall/getchives", {
					id: 46,
				}).then(res => {
					that.list = res.data;
					if (that.list.length > 0) {
						
						if(that.active == 0){
							that.$data.active = that.$data.list[0].id;
							that.content = that.$data.list[0].content;
							that.title = that.$data.list[0].title;
						}else{
							that.content = that.$data.list[that.index].content;
							that.title = that.$data.list[that.index].title;
						}
						
					}

				}).catch(error => {
					
				})
			},

		}


	}
</script>
